/* eslint-disable no-unused-vars */
// import api from '@utils/api'
import set from 'lodash/set'
import find from 'lodash/find'
import difference from 'lodash/difference'
import get from 'lodash/get'
import range from 'lodash/range'

import api from '@utils/api'

import htmlTemplates from '@staticTemplate/htmlTemplates';
import { setDynamicDocumentsList } from '@actions/documents'

import { mainClassForSection, getBase64Image, setValuesIntoHtmlSection, getValuesIntoHtmlSection, loadCSS, loadJS, mergeHtmlToFinalLayout, setInfoFilterComponent, getLabelCompleteInTree, getLabelCompleteInTreeES } from '@utils/general'

import { SET_VALUES_SECTION, SET_CATALOG } from '@constants/actionType';
import { catalogoClass } from '@constants/seccion';
import { LANGUAGE_DEFAULT, StatusVisible, SECTION_HOME_ID, AuthorizedStatusInt, AuthorizedStatusSend, SECTION_HOME_ALIADOS_NAME, SECTION_TEMPLATE_TYPES } from '@constants/general';




export const getSections = (querys = {}) => async (_dispatch, _getState) => {
  if (!querys?.type) querys.type = 'all'
  const response = await api.getListSection(querys)
  return response;
};

export const deleteSection = ({ id, type, justification }) => async (_dispatch, getState) => {
  if (!type) return true
  const data = {
    reason: justification,
  }
  const response = await api.deleteSection(id, { type }, data)
  return response;
};

export const reOrderSections = (data) => async () => {

  const response = await api.reOrderSections(data)
  return response;
};

export const getSectionLayout = () => async () => {
  const response = htmlTemplates[2].templete;
  return response;
};

export const updateVisibilityStatus = ({ id, visible, justification }) => async (_dispatch, _getState) => {
  let validateStatus = null
  if (visible === StatusVisible.IS_VISIBLE) validateStatus = 'hide'
  if (visible === StatusVisible.IS_HIDDEN) validateStatus = 'show'
  const data = {
    status: validateStatus,
    reason: justification
  }
  const response = await api.updateVisibilitySection(id, data)
  return response;
};

export const reactiveSection = ({ id, justification }) => async (_dispatch, _getState) => {
  const data = {
    reason: justification
  }
  const response = await api.reactiveSection(id, data)
  return response;
};
export const confirmDeleteSection = ({ id, justification }) => async (_dispatch, _getState) => {
  console.log('Confirmar Eliminacion seccion')
  return true;
};

export const getDetailSection = ({ id }) => async (_dispatch, _getState) => {
  const response = await api.getDetailSection(id)
  return response;
};
/* 
export const generateLayoutsHtml = ({componentsAvailables, componentsSelected}) => async (dispatch, getState) => {
  const { section, catalogs } = getState()
  const keysLenguages = catalogs.keysLanguageCatalog

  const layoutHtml = await dispatch(getSectionLayout())
  const newHtml = document.createElement( 'html' );
  newHtml.innerHTML = layoutHtml
  console.log(newHtml)

  console.log('componentsSelected', componentsSelected)

  // const head  = newHtml.getElementsByTagName('head')[0];
  // loadCSS(head)

  // const body  = newHtml.getElementsByTagName('body')[0];
  // loadJS(body)
  const validateComponentsAvailables = catalogoClass.reduce((accum, section) => {
    const existSelected = componentsSelected.find(item => item.componentName === section.componentName)
    if (!existSelected) accum.push(section)
    return accum
  }, [])
  console.log('validateComponentsAvailables',validateComponentsAvailables)

  validateComponentsAvailables.map(item => {
    const parentClass = item.parentClass.class
    const getElement = newHtml.getElementsByClassName(parentClass)
    while (getElement.length > 0) {
      getElement[0].remove();
    }
  })
  const getSectionsElements = componentsSelected.map(item => {
    const parentClass = item.parentClass.class
    return newHtml.querySelector(`.${parentClass}`).cloneNode(true);
  })
  componentsSelected.map(item => {
    const parentClass = item.parentClass.class
    const getElement = newHtml.getElementsByClassName(parentClass)
    while (getElement.length > 0) {
      getElement[0].remove();
    }
  })

  componentsSelected.map((item, index) => {
    const classContainer = item.containerClass
    const getElementContainer = newHtml.getElementsByClassName(classContainer)
    // const getElementContainer = newHtml.getElementsByTagName("BODY")
    return getElementContainer[0].appendChild(getSectionsElements[index])
  })

  // return this.setContentByLanguages(newHtml)

  const layoutByLanguage = keysLenguages.map((language, index) => {
    const cloneLayout = newHtml.cloneNode(true)
    componentsSelected.map(async sectionItem => {
      console.log('sectionItem', sectionItem)
      if (sectionItem.isFilterComponent) setInfoFilterComponent({cloneLayout,state: section, sectionItem, language})
      sectionItem.parentClass.childrenClass.map(async item => {
        return await setValuesIntoHtmlSection({
          item,
          cloneLayout,
          state: section,
          language
        })
      })
    })
    return {
      language,
      html: cloneLayout
    }
  })
  console.log('layoutByLanguage', layoutByLanguage)

  // layoutByLanguage = await dispatch(setDynamicDocumentsList(layoutByLanguage))

  await dispatch({
    type: SET_VALUES_SECTION,
    payload: { layoutsHtml: layoutByLanguage }
  })
  return layoutByLanguage
} */

const createLayoutElement = html => {
  const layout = document.createElement('html')
  layout.innerHTML = html
  return layout
}

const getComponentsContainer = layout => layout.getElementsByClassName('dynamic-elements-content')[0]

const createPreviewLayout = (cleanLayout, generatedLayout) => {
  const generatedHtml = generatedLayout.outerHTML
  const requiresPreviewShell = generatedHtml.includes('th:replace') || generatedHtml.includes('th:insert')

  if (!requiresPreviewShell) return generatedLayout.cloneNode(true)

  const previewLayout = cleanLayout.cloneNode(true)
  const previewMain = previewLayout.getElementsByTagName('main')[0]
  const generatedMain = generatedLayout.getElementsByTagName('main')[0]

  if (previewMain && generatedMain) previewMain.replaceWith(generatedMain.cloneNode(true))

  return previewLayout
}

export const generateLayoutsHtml = ({ componentsAvailables, componentsSelected }) => async (dispatch, getState) => {
  const { section, catalogs } = getState()
  const keysLenguages = catalogs.keysLanguageCatalog
  const sectionName = section.general[LANGUAGE_DEFAULT]?.titleSeccion
  const shouldNormalizeHomeAliados = sectionName === SECTION_HOME_ALIADOS_NAME
  const cleanLayoutHtml = await dispatch(getSectionLayout())
  const cleanLayout = createLayoutElement(cleanLayoutHtml)
  const originalHtmlByLanguage = section.originalHtmlByLanguage || {}

  const layoutByLanguage = await Promise.all(keysLenguages.map(async language => {
    const storedHtml = originalHtmlByLanguage[language]
    const storedLayout = storedHtml ? createLayoutElement(storedHtml) : null
    const hasValidStoredLayout = !!(
      storedLayout
      && storedLayout.getElementsByTagName('main').length
      && getComponentsContainer(storedLayout)
    )
    const cloneLayout = hasValidStoredLayout ? storedLayout : cleanLayout.cloneNode(true)
    const componentsContainer = getComponentsContainer(cloneLayout)
    const cleanComponentsContainer = getComponentsContainer(cleanLayout)

    const sectionElements = componentsSelected.map(sectionItem => {
      const parentClass = sectionItem.parentClass.class
      const storedElement = hasValidStoredLayout
        ? componentsContainer.querySelector(`.${parentClass}`)
        : null
      const cleanElement = cleanComponentsContainer.querySelector(`.${parentClass}`)
      const requiresStableStructure = sectionItem.componentName === 'CapacitateEmpleo'
      const sourceElement = requiresStableStructure
        ? cleanElement
        : storedElement || cleanElement

      return sourceElement ? sourceElement.cloneNode(true) : null
    })

    catalogoClass.map(sectionItem => {
      const parentClass = sectionItem.parentClass.class
      const elements = componentsContainer.getElementsByClassName(parentClass)
      while (elements.length > 0) elements[0].remove()
      return true
    })

    componentsSelected.map((sectionItem, index) => {
      if (sectionElements[index]) componentsContainer.appendChild(sectionElements[index])
      return true
    })

    await Promise.all(componentsSelected.map(async sectionItem => {
      if (sectionItem.isFilterComponent) {
        setInfoFilterComponent({ cloneLayout, state: section, sectionItem, language })
      }

      await Promise.all(sectionItem.parentClass.childrenClass.map(item => setValuesIntoHtmlSection({
        item,
        cloneLayout,
        state: section,
        language,
        cleanLayout
      })))
    }))

    if (shouldNormalizeHomeAliados) normalizeLayoutForHomeAliados(cloneLayout)

    return {
      language,
      html: cloneLayout,
      previewHtml: createPreviewLayout(cleanLayout, cloneLayout),
      preserveDocument: hasValidStoredLayout
    }
  }))

  await dispatch({
    type: SET_VALUES_SECTION,
    payload: { layoutsHtml: layoutByLanguage }
  })

  return layoutByLanguage
}

const normalizeLayoutForHomeAliados = cloneLayout => {
  normalizeHomeAliadosCodeEthicsButton(cloneLayout)
}

const normalizeHomeAliadosCodeEthicsButton = cloneLayout => {
  const button = cloneLayout.querySelector('.sct-banner-code-ethics-btn')

  if (!button) {
    return
  }

  const documentId = button.getAttribute('data-documentid')
  const id = button.getAttribute('id')

  const fullDocumentId = documentId || id

  if (!fullDocumentId) {
    return
  }

  button.setAttribute('data-documentid', fullDocumentId)

  if (fullDocumentId.includes('-')) {
    button.setAttribute('id', fullDocumentId.split('-')[0])
    return
  }

  button.setAttribute('id', fullDocumentId)
}

export const _generateLayoutsHtml = (params) => async (dispatch, getState) => {
  const { section, catalogs } = getState()
  const { componentsAvailables, componentsSelected } = section
  const keysLenguages = catalogs.keysLanguageCatalog

  const layoutHtml = await dispatch(getSectionLayout())
  const newHtml = document.createElement('html');
  newHtml.innerHTML = layoutHtml

  componentsAvailables.map(item => {
    const parentClass = item.parentClass.class
    const getElement = newHtml.getElementsByClassName(parentClass)
    while (getElement.length > 0) {
      getElement[0].remove();
    }
  })
  const getSectionsElements = componentsSelected.map(item => {
    const parentClass = item.parentClass.class
    return newHtml.querySelector(`.${parentClass}`).cloneNode(true);
  })
  componentsSelected.map(item => {
    const parentClass = item.parentClass.class
    const getElement = newHtml.getElementsByClassName(parentClass)
    while (getElement.length > 0) {
      getElement[0].remove();
    }
  })

  componentsSelected.map((item, index) => {
    const classContainer = item.containerClass
    const getElementContainer = newHtml.getElementsByClassName(classContainer)
    return getElementContainer[0].appendChild(getSectionsElements[index])
  })

  // return this.setContentByLanguages(newHtml)

  const layoutByLanguage = keysLenguages.map((language, index) => {
    const cloneLayout = newHtml.cloneNode(true)
    componentsSelected.map(async sectionItem => {
      sectionItem.parentClass.childrenClass.map(async item => {
        const getElement = cloneLayout.getElementsByClassName(item.class)
        return await setValuesIntoHtmlSection(getElement, item, section, language)
      })
    })
    return {
      language,
      html: cloneLayout
    }
  })
  layoutByLanguage.map()
  await dispatch({
    type: SET_VALUES_SECTION,
    payload: { layoutsHtml: layoutByLanguage }
  })
  return layoutByLanguage
}

export const extractInformationSection =
  ({ nombre, description, id_padre, id, editable, plantilla, estatus, id_original }) =>
    async (dispatch, getState) => {
      const { catalogs } = getState()
      const keysLenguages = catalogs.keysLanguageCatalog

      const general = keysLenguages.reduce((accum, language) => {
        const getTitle = nombre[language] || ''
        // const getDescription = description[language] || ''
        accum[language] = { titleSeccion: getTitle }
        return accum
      }, {})

      const decryptHtml = {}
      Object.keys(plantilla).map((key, index) => {
        console.log('key', key)
        console.log('index', plantilla[key])
        decryptHtml[key] = decodeURIComponent(escape(window.atob(plantilla[key])))
        // Buffer.from(plantilla[key], 'base64')
      })
      console.log('decrypt', decryptHtml)
      const layoutDefault = decryptHtml[keysLenguages[0]]

      const formatHtml = document.createElement('html');
      formatHtml.innerHTML = layoutDefault
      const getAllClass = Array.from(formatHtml.querySelectorAll('[class]')).flatMap(e => e.className.toString().split(/\s+/))
      const getClassSelected = getAllClass.reduce((accum, item) => {
        const existClass = mainClassForSection().indexOf(item)
        if (existClass !== -1) accum.push(item)
        return accum
      }, [])
      const componentsSelected = getClassSelected.map(parentClass => find(catalogoClass, (shift) => { return shift.parentClass.class === parentClass }))
      const componentsAvailables = difference(catalogoClass, componentsSelected);

      let stateComponents = {}

      keysLenguages.map(language => {
        let layoutHtml = decryptHtml[language]
        const html = document.createElement('html');
        html.innerHTML = layoutHtml || decryptHtml[LANGUAGE_DEFAULT]
        componentsSelected.map(async section => {
          section.parentClass.childrenClass.map(async option => {
            await getValuesIntoHtmlSection({ option, html, stateComponents, language })
          })
        })
      })

      console.log('stateComponents', stateComponents)

      dispatch({
        type: SET_VALUES_SECTION,
        payload: {
          general: { ...general, selectedNavegationTree: id_padre },
          // visibility: _visibility,
          componentsAvailables,
          componentsSelected,
          editable,
          estatus,
          selectedNavegationTree: id_padre,
          id,
          id_original,
          originalHtmlByLanguage: decryptHtml,
          ...stateComponents
        },
      });
    };
export const _extractInformationSection =
  ({ title, description, parentSection, visibility, isAllCountriesVisible, layouts }) =>
    async (dispatch, getState) => {
      const { catalogs } = getState()
      const keysLenguages = catalogs.keysLanguageCatalog

      const general = keysLenguages.reduce((accum, language) => {
        const getTitle = title[language] || ''
        const getDescription = description[language] || ''
        accum[language] = { titleSeccion: getTitle, description: getDescription }
        return accum
      }, {})

      const _visibility = {
        optionCountry: visibility,
        isAllCountriesVisible
      }

      const layoutDefault = layouts[keysLenguages[0]]

      const formatHtml = document.createElement('html');
      formatHtml.innerHTML = layoutDefault
      const getAllClass = Array.from(formatHtml.querySelectorAll('[class]')).flatMap(e => e.className.toString().split(/\s+/))
      console.log('mainClassForSection()', mainClassForSection())
      const getClassSelected = getAllClass.reduce((accum, item) => {
        const existClass = mainClassForSection().indexOf(item)
        if (existClass !== -1) accum.push(item)
        return accum
      }, [])
      const componentsSelected = getClassSelected.map(parentClass => find(catalogoClass, (shift) => { return shift.parentClass.class === parentClass }))
      const componentsAvailables = difference(catalogoClass, componentsSelected);

      console.log('componentsSelected', componentsSelected)
      console.log('componentsAvailables', componentsAvailables)

      let stateComponents = {}

      keysLenguages.map(language => {
        const layoutHtml = layouts[language]
        const existLayoutOfLanguage = layoutHtml ? true : false
        const html = document.createElement('html');
        html.innerHTML = layoutHtml
        componentsSelected.map(section => {
          section.parentClass.childrenClass.map(async option => {
            const getElement = html.getElementsByClassName(option.class)
            let stateValue = option.valueState
            if (stateValue.includes('$language')) stateValue = stateValue.replace('$language', language)
            let getValueOfElement = ''

            if (option.isDinamyc) {
              if (!existLayoutOfLanguage) { // Caso cuando se agrega un nuevo idioma y la seccio no cuenta con este layout
                let valueDefualt = option.valueState.replace('$language', LANGUAGE_DEFAULT)
                option.childrenClass.map(optionChildren => {
                  const lengthStatebyDefaultLanguage = get(stateComponents, valueDefualt, []).length
                  range(lengthStatebyDefaultLanguage).map((item, index) => {
                    let stateValueChildren = optionChildren.valueState
                    if (stateValueChildren.includes('$language')) stateValueChildren = stateValueChildren.replace('$language', language)
                    if (stateValueChildren.includes('$index')) stateValueChildren = stateValueChildren.replace('$index', index)
                    if (optionChildren.isLink) {
                      let stateValueLinkChildren = optionChildren.valueLink
                      if (optionChildren.valueLink.includes('$language')) stateValueLinkChildren = stateValueLinkChildren.replace('$language', language)
                      if (optionChildren.valueLink.includes('$index')) stateValueLinkChildren = stateValueLinkChildren.replace('$index', index)
                      set(stateComponents, stateValueLinkChildren, '')
                    }
                    set(stateComponents, stateValueChildren, optionChildren.defaultValue)
                  })
                })
                return true
              } else {
                return getElement[0].childNodes.forEach((childrenTag, index) => {
                  option.childrenClass.map(optionChildren => {
                    let getValueOfElementChildren = ''
                    let getElementChild = childrenTag.getElementsByClassName(optionChildren.class)
                    let stateValueChildren = optionChildren.valueState
                    if (stateValueChildren.includes('$language')) stateValueChildren = stateValueChildren.replace('$language', language)
                    if (stateValueChildren.includes('$index')) stateValueChildren = stateValueChildren.replace('$index', index)
                    if (optionChildren.isLink) {
                      let stateValueLinkChildren = optionChildren.valueLink
                      if (optionChildren.valueLink.includes('$language')) stateValueLinkChildren = stateValueLinkChildren.replace('$language', language)
                      if (optionChildren.valueLink.includes('$index')) stateValueLinkChildren = stateValueLinkChildren.replace('$index', index)
                      let valueLinkChildren = (getElementChild && getElementChild.length && getElementChild[0].getAttribute('href')) || '#'
                      set(stateComponents, stateValueLinkChildren, valueLinkChildren)
                    }
                    if (optionChildren.isCustomText) getValueOfElementChildren = (getElementChild && getElementChild.length && getElementChild[0].innerHTML) || optionChildren.defaultValue
                    else getValueOfElementChildren = (getElementChild && getElementChild.length && getElementChild[0].innerText) || optionChildren.defaultValue
                    set(stateComponents, stateValueChildren, getValueOfElementChildren)
                  })
                })
              }
            }

            if (option.isRemove) {
              if (!existLayoutOfLanguage) {
                let valueDefualt = option.valueRemove.replace('$language', LANGUAGE_DEFAULT)
                set(stateComponents, valueDefualt, get(stateComponents, valueDefualt))

              } else {
                set(stateComponents, option.valueRemove, getElement.length ? true : false)
              }
            }

            if (option.isImg && getElement) {
              const getImg = getElement[0].src
              const file = getBase64Image(getImg, 'base')
              const localUrl = URL.createObjectURL(file);
              const formatImg = [
                {
                  fileName: stateValue,
                  currentValue: localUrl,
                  file
                }
              ]
              getValueOfElement = formatImg || option.defaultValue
            } else if (option.isCustomText) getValueOfElement = (getElement && getElement.length && getElement[0].innerHTML) || option.defaultValue
            else getValueOfElement = (getElement && getElement.length && getElement[0].innerText) || option.defaultValue
            set(stateComponents, stateValue, getValueOfElement)
          })
        })
      })

      console.log('stateComponents', stateComponents)

      dispatch({
        type: SET_VALUES_SECTION,
        payload: {
          general,
          visibility: _visibility,
          componentsAvailables,
          componentsSelected,
          ...stateComponents
        },
      });
    };

export const addSection = (isLanding = true, status = AuthorizedStatusInt.STATUS_EDITION) => async (_dispatch, getState) => {
  const { layoutsHtml, selectedLabelNavegationTree, selectedNavegationTree, visibility, general, componentsSelected } = getState().section
  const { keysLanguageCatalog } = getState().catalogs
  const templateType = getSectionTemplateType(general)
  const data = {
    nombre: {},
    descripcion: { "es": "" },
    plantilla: {},
    visible: status === AuthorizedStatusInt.STATUS_AUTHORIZED ? 1 : 0,
    editable: 1,
    estatusId: status,
    // countries: {},
    // sectionPath: selectedLabelNavegationTree.replace(".", ""),
    id_padre: selectedNavegationTree
  }
  await keysLanguageCatalog.map(key => {
    data.nombre[key] = general[key].titleSeccion
    // data.descripcion[key] = general[key].description
    return true
  })

  if (isLanding) {
    // data.countries.tipo = visibility.isAllCountriesVisible ? 'all' : 'some'
    // data.countries.lista = !visibility.isAllCountriesVisible
    //   ? visibility.optionCountry.map(item => ({id: item}))
    //   : []
    await layoutsHtml.map(item => {
      const title = general[item.language].titleSeccion || general[LANGUAGE_DEFAULT].titleSeccion
      const formattingHtml = mergeHtmlToFinalLayout(item.html, title, componentsSelected, { templateType })
      const encodedHtml = window.btoa(unescape(encodeURIComponent(formattingHtml)))
      // const encodedHtml =  window.btoa(formattingHtml)
      data.plantilla[item.language] = encodedHtml
      // atob(encoded) // Decodificar base 64
      return true
    })
  }
  const response = await api.addSection(data)
  if (!response?.status) {
    const refreshPromise = keysLanguageCatalog.map(key => {
      const name = data.nombre[LANGUAGE_DEFAULT].replace(" ", "-")
      return api.refreshCache(`${name}-ln=${key}`)
    })
    await Promise.all(refreshPromise)
  }
  return response;
};

export const updateSection = (isLanding = true) => async (_dispatch, getState) => {
  const { layoutsHtml, selectedLabelNavegationTree, selectedNavegationTree, visibility, general, id, componentsSelected, id_original } = getState().section
  const { keysLanguageCatalog, sectionTreeCurrentCatalog } = getState().catalogs
  const templateType = getSectionTemplateType(general)
  let getRuta = ""
  if (id !== SECTION_HOME_ID) {
    if (id_original !== SECTION_HOME_ID) getRuta = getLabelCompleteInTreeES(sectionTreeCurrentCatalog, selectedNavegationTree, '')
  }
  const data = {
    id,
    nombre: {},
    descripcion: { "es": "" },
    plantilla: {},
    // countries: {},
    // sectionPath: selectedLabelNavegationTree.replace(".", ""),
    id_padre: selectedNavegationTree,
    ruta: getRuta
  }
  if (!data.id_padre) delete data.id_padre
  keysLanguageCatalog.map(key => {
    data.nombre[key] = general[key].titleSeccion
    // data.descripcion[key] = general[key].description
  })

  if (isLanding) {
    // data.countries.tipo = visibility.isAllCountriesVisible ? 'all' : 'some'
    // data.countries.lista = !visibility.isAllCountriesVisible
    //   ? visibility.optionCountry.map(item => ({id: item}))
    //   : []
    await layoutsHtml.map(item => {
      const title = general[item.language].titleSeccion || general[LANGUAGE_DEFAULT].titleSeccion
      const formattingHtml = mergeHtmlToFinalLayout(item.html, title, componentsSelected, {
        templateType,
        preserveDocument: item.preserveDocument
      })
      const encodedHtml = window.btoa(unescape(encodeURIComponent(formattingHtml)))


      data.plantilla[item.language] = encodedHtml
      // atob(encoded) // Decodificar base 64
      return true
    })
  }
  console.log('------>', data)
  const response = await api.editSection(data)
  if (!response?.status) {
    const refreshPromise = keysLanguageCatalog.map(key => {
      const name = data.nombre[LANGUAGE_DEFAULT].replace(" ", "-")
      return api.refreshCache(`${name}-ln=${key}`)
    })
    await Promise.all(refreshPromise)
  }
  return response;
};

const getSectionTemplateType = (general = {}) => {
  const sectionName = general[LANGUAGE_DEFAULT]?.titleSeccion

  if (sectionName === SECTION_HOME_ALIADOS_NAME) {
    return SECTION_TEMPLATE_TYPES.HOME_ALIADOS
  }

  return SECTION_TEMPLATE_TYPES.DEFAULT
}

export const rejectSection = (data) => async (_dispatch, _getState) => {
  return true;
};

export const getSectionTree = (querys = {}) => async (dispatch, _getState) => {
  const response = await api.getSectionTree({ type: 'all' })
  if (!response.status) {
    dispatch({
      type: SET_CATALOG,
      payload: { nameCatalog: 'categoriesSectionCatalog', data: response.data }
    })
  }
  return response;
};

export const getAllSectionTree = () => async (dispatch, _getState) => {
  const response = await api.getAllSectionTree({ type: 'all' })
  return response;
};

export const updateStatusSection = ({ id, status, justification = '', idOriginal = null, selectedNavegationTree }) => async (dispatch, getState) => {
  // @idOriginal solo para autorizar
  // @selectedNavegationTree (IdSectionFather) solo para autorizar
  const { sectionTreeCurrentCatalog } = getState().catalogs

  const data = {
    status,
    reason: justification
  }

  const querys = {}

  if (status === AuthorizedStatusSend.STATUS_AUTHORIZED) {
    if (id !== SECTION_HOME_ID) {
      if (idOriginal !== SECTION_HOME_ID) {
        querys.ruta = getLabelCompleteInTreeES(sectionTreeCurrentCatalog, selectedNavegationTree, '')
      }
    }
  }

  const response = await api.updateStatusSection(id, data, querys)
  return response;
};

